import { memo, useMemo } from "react";
import { markMatch, prepareForMatching } from "@datassential/platform-ui-lib";
import { IMacItem } from "@apiHooks/useMacsList";
import MoreLabel from "./MoreLabel";

interface RowDescriptionProps {
    query: string;
    row: IMacItem;
}

const RowDescription = ({ query, row }: RowDescriptionProps) => {
    const sanitizedQuery = useMemo(() => prepareForMatching(query), [query]);
    const sanitizedAdditional = useMemo(
        () => prepareForMatching(row.description.additional),
        [row.description.additional]
    );
    const hasMatchInAdditional = useMemo(
        () => markMatch(sanitizedAdditional, sanitizedQuery, true).includes(sanitizedQuery),
        [sanitizedAdditional, sanitizedQuery]
    );
    const highlightedPreview = useMemo(
        () => sanitizedQuery === ''
            ? row.description.preview
            : markMatch(row.description.preview, sanitizedQuery, true),
        [sanitizedQuery, row.description.preview]
    );
    
    return (
        <div>
            <div
                className="MacsListTable__row-description-preview"
                dangerouslySetInnerHTML={{
                    __html: highlightedPreview
                }}
            />
            {' '}
            {row.itemsCount > 2 && (
                <MoreLabel
                    rowId={row.id} 
                    count={row.itemsCount - 2} 
                    isHighlighted={!!sanitizedQuery && hasMatchInAdditional} 
                />
            )}
        </div>
    );
};

export default memo(RowDescription);